import { useState } from 'react';
import { useTheme, styled } from '@mui/material/styles';
import { Grid, Stack, Typography, Link, useMediaQuery, Box, Button } from '@mui/material';
import { KeyRounded } from '@mui/icons-material';
import RegisterDialog from './RegisterDialog';
import AuthCardWrapper from '../../components/Cards/AuthCardWrapper';
import logoImg from '../../assets/images/LargeWakeSmart.JPG';

const AuthWrapper = styled('div')(({ theme }) => ({
    background: `linear-gradient(white, ${theme.palette.primary.main})`
    // minHeight: '100vh'
}));

const RegisterOrganization = () => {
    const theme = useTheme();
    const [showRegisterDialog, setShowRegisterDialog] = useState(false);
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <AuthWrapper>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item sx={{ mb: 3 }}>
                                        <Link href="/">
                                            <img src={logoImg} width="150" alt="" />
                                        </Link>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction={matchDownSM ? 'column-reverse' : 'row'}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item>
                                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                    <Typography
                                                        color={theme.palette.primary.main}
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h3' : 'h2'}
                                                        sx={{ textAlign: 'center' }}
                                                    >
                                                        Register your Organization with WakeSMART!
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box sx={{ mt: 2, mb: 2 }}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                startIcon={<KeyRounded />}
                                                onClick={() => setShowRegisterDialog(true)}
                                            >
                                                Register using an Organization Key
                                            </Button>
                                        </Box>
                                        {/*<Box sx={{ mt: 4, mb: 2 }}>*/}
                                        {/*    <Button fullWidth variant="contained" startIcon={<EmailOutlined />}>*/}
                                        {/*        Register by email to use WakeSMART*/}
                                        {/*    </Button>*/}
                                        {/*</Box>*/}
                                        <Box sx={{ mt: 4, mb: 2, fontFamily: 'Roboto', fontWeight: '500', textAlign: 'center' }}>
                                            <Link href="https://www.wakesmart.eco/wakesmart/" sx={{ textDecoration: 'none' }}>
                                                What is WakeSMART?
                                            </Link>
                                        </Box>
                                    </Grid>
                                    {showRegisterDialog && <RegisterDialog onClose={() => setShowRegisterDialog(false)} />}
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
};

export default RegisterOrganization;
